import {columns} from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/companyLocation'
export const namespace = 'companyLocation'
export const clientRoute = '/company/company-location'
export const dependencies = ['company', 'address']
export const params = {
  include: 'Company,Address'
}
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
